import { CSSProperties } from 'react';
import { RegisterOptions, useFormContext } from 'react-hook-form';
import classNames from 'classnames';
import styles from 'styles/components/common/forms/FormRadioBtn.module.scss';

type TProps = {
  labelText: string;
  name: string;
  rules?: RegisterOptions;
  value: string;
  disabled?: boolean;
  readOnly?: boolean;
  radioStyle?: CSSProperties;
  labelStyle?: CSSProperties;
  afterChange?: (value: string | number | boolean | string[]) => void;
};

const FormRadioBtn = ({
  labelText,
  name,
  rules,
  value,
  disabled,
  readOnly,
  radioStyle,
  labelStyle,
  afterChange,
}: TProps) => {
  const { register } = useFormContext();

  const handleChange = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    afterChange?.(value as any);
  };

  return (
    <div style={radioStyle}>
      <label
        className={classNames(styles.label, {
          [styles.disabled]: disabled,
          [styles.readonly]: readOnly,
        })}
        style={labelStyle}
      >
        <input
          {...register(name, { ...rules, onChange: handleChange })}
          name={name}
          value={value}
          type="radio"
          className={styles.input}
          disabled={disabled || readOnly}
        />
        {labelText}
      </label>
    </div>
  );
};

export default FormRadioBtn;
